
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
export default {
  name: 'ProductListingMobileCard',

  mixins: [eventTrackingMixins],

  props: {
    data: {
      type: Object,
      default: () => {}
    },
    showComparison: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    toggleDecoderCTAModal(popupData) {
      this.$store.commit('modal/setShowDecoderCTAModal', true);
      popupData.trackingData = {
        scenarioCode: this.data.id,
        productName: this.data.productName,
        category: this.data.category || this.data.productType,
        insurerName: this.data.insuranceCompany.name,
        insurerCode: this.data.insuranceCompany.code,
        eventCategory: this.$route.path.includes('insurer')? 'insurer_decoder_card_cta' : 'decoder_cta_popup'
      }
      this.$store.commit('modal/setDecoderCTAModalData', popupData);
    },

    handleCTAButtonClicked(event, dataMainButtonCTA) {

      // #219 Insurer_decoder_card_cta
      if(this.$route.path.includes('insurer') & dataMainButtonCTA?.type === 'popup') {
        const eventTrackingParams = this.initEventTrackingParams()

        eventTrackingParams.a = 'open_cta_popup';
        eventTrackingParams.l = this.data.id;
        eventTrackingParams.c = 'Insurer_decoder_card_cta';
        eventTrackingParams.cd.insurer_name = this.data.insuranceCompany.name;
        eventTrackingParams.cd.product_name = this.data.productName;
        eventTrackingParams.cd.product_category = this.data.category || this.data.productType;

        if(eventTrackingParams.a !== ''){
            this.sendEventTracking(eventTrackingParams)
        }
      }

      if (dataMainButtonCTA?.type === 'popup') {
        this.toggleDecoderCTAModal(dataMainButtonCTA.popupData);
        return;
      }

    },
  },
};
